// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FasuaEditorMountController from "./fasua_editor_mount_controller"
application.register("fasua-editor-mount", FasuaEditorMountController)

import FasuaReviewMountController from "./fasua_review_mount_controller"
application.register("fasua-review-mount", FasuaReviewMountController)

import McpSetupController from "./mcp_setup_controller"
application.register("mcp-setup", McpSetupController)

import DailyChartController from "./daily_chart_controller"
application.register("daily-chart", DailyChartController)

import { registerControllers } from "@radioactive-labs/plutonium"
registerControllers(application)
